import { WebServiceService } from '../../shared/services/web-service.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-scanning',
  templateUrl: './loader-scanning.component.html',
  styleUrls: ['./loader-scanning.component.scss']
})
export class LoaderScanningComponent implements OnInit {

  animationArr = ["https://tyasuite.s3.ap-southeast-1.amazonaws.com/generics/uploading-invoice.gif", 
                  "https://tyasuite.s3.ap-southeast-1.amazonaws.com/generics/invoice-scanner.gif", 
                  "https://tyasuite.s3.ap-southeast-1.amazonaws.com/generics/reading-invoice.gif"];

  animationTxtArr = ["Uploading Document", 
                      "Scanning Content", 
                      "Analyzing Results"];

  currentAnimationIndex: any = 0;
  currentAnimation: any = "";
  currentAnimationTxt: any = "";
  constructor(private dataService: WebServiceService) { }

  ngOnInit() {

    // this.currentAnimation = this.animationArr[this.currentAnimationIndex];

    this.dataService.invScanningData$.subscribe(data => {

      // console.log(data);

      this.currentAnimationIndex = data;
      this.currentAnimation = this.animationArr[this.currentAnimationIndex];
      this.currentAnimationTxt = this.animationTxtArr[this.currentAnimationIndex];
    });

    
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src62925525/src/src/app/common/loader-scanning/loader-scanning.component.ts